import { Fragment } from "react";
import { Grid as MuiGrid, Box as MuiBox } from "@mui/material";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import type { IToken } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";
import { Typography } from "@dzambalaorg/ui-kit";

import { DismantleTokenPanel } from "../../../mechanics/gaming/recipes/dismantle/dismantle-token-panel";
import { TokenHistory, CommonTokenPanel } from "../../../../components/common";

export const Erc1155Token = () => {
  const { data, isLoading, isError } = useFetchData<IToken>("/erc1155/tokens");

  if (isLoading) {
    return <Spinner />;
  }

  if (isError || !data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc1155", "erc1155.token"]} data={[{}, {}, data.template]} />

      <PageHeader message="pages.erc1155.token.title" data={data.template} />

      <MuiGrid container>
        <MuiGrid size={{ xs: 12, sm: 9 }}>
          <MuiBox component="img" src={data.template!.imageUrl} alt="Cascadify token image" width={300} height={300} />
          <Typography variant="body2">
            <RichTextDisplay data={data.template!.description} />
          </Typography>
        </MuiGrid>
        <MuiGrid size={{ xs: 12, sm: 3 }}>
          {data.templateId ? (
            <>
              <CommonTokenPanel token={data} />
              <DismantleTokenPanel token={data} />
              {/*<OpenSeaTokenPanel token={data} />*/}
            </>
          ) : null}
        </MuiGrid>
      </MuiGrid>

      {data.id ? <TokenHistory token={data} /> : null}
    </Fragment>
  );
};
